const files = require.context('.', true, /\.js$/)
const module = {}

const validateDesc = function (errors, vm) {
  const descList = this.descList
  if (descList && descList.some(item => !item.optionName)) {
    errors.push('题目内容不能为空！')
    return false
  }
  return true
}

const validateOption = function (errors, vm) {
  const optionList = this.optionList
  if (optionList && optionList.some(item => !item.optionName)) {
    errors.push('选项内容不能为空！')
    return false
  }
  return true
}

const validate = function (vm) {
  const errors = []
  return {
    result: validateDesc.call(this, errors, vm) & validateOption.call(this, errors, vm),
    errors
  }
}

files.keys().forEach((key) => {
  if (key === './index.js' || key === './config.js' || key === './logic.js' || key === './answer.js' || key === './validate.js' ||
  key === './answerValidate.js') {
    return
  }
  const moduleName = key.substring(key.indexOf('/') + 1, key.lastIndexOf('/'))
  if (key.indexOf('validate') > -1) {
    const { validateDesc, validateOption, validate } = files(key).default
    module[moduleName] = {
      validateDesc,
      validateOption,
      validate
    }
  } else if (!module[moduleName]) {
    module[moduleName] = {
      validateDesc,
      validateOption,
      validate
    }
  }
})
export default module



// WEBPACK FOOTER //
// ./src/components/editor/validate.js